import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./Components/Pages/Login";
import Reset from "./Components/Pages/Reset";
import Register from "./Components/Pages/Register";
import Dashboard from "./Components/Pages/Dashboard";
import Landing from "./Components/Pages/Landing";
import PromptGuide from "./Components/Pages/PromptGuide";
import ClosedBeta from "./Components/Pages/ClosedBeta";
import ChooseModel from "./Components/3D/ChooseModel";
import TexturingContainer from "./Components/3D/TexturingContainer";
import SignIn3DTexturing from "./Components/Pages/SignIn3DTexturing";
import TexturingEmailCollection from "./Components/3D/TexturingEmailCollection";
import PartialTexturing from "./Components/3D/PartialTexturing";
import SignIn3DTexturingVolumetric from "./Components/Pages/SignIn3DTexturingVolumetric";
import TexturingMainLanding from "./Components/3D/Landing/TexturingMainLanding";

function App() {

  return (
    <div className="App">
      <Router>
        <Routes>
            <Route key="landing" path="/" element={<Landing/>} exact={true}/>
            <Route key="signin" path="/signin" element={<Login/>} exact={true}/>
            <Route key="reset" path="/reset" element={<Reset/>} exact={true}/>
            {/*<Route key="register" path="/register" element={<Register/>} exact={true}/>*/}
            <Route key="dashboard" path="/dashboard" element={<Dashboard/>} exact={true}/>
            <Route key="prompt" path="/prompt-guide" element={<PromptGuide/>} exact={true}/>
            <Route key="closed-beta" path="/closed-beta" element={<ClosedBeta/>} exact={true}/>

            <Route key="signin-3d-texturing" path="/signin-3d-texturing" element={<SignIn3DTexturing/>} exact={true}/>
            <Route key="3d-texturing-p" path="/3d-texturing-p" element={<PartialTexturing/>} exact={true}/>
            <Route key="3d-texturing-volumetric" path="/3d-texturing-volumetric" element={<TexturingContainer isVolumetric={true}/>} exact={true}/>
            <Route key="signin-3d-texturing-volumetric" path="/signin-3d-texturing-volumetric" element={<SignIn3DTexturingVolumetric/>} exact={true}/>
            <Route key="3d-texturing-landing" path="/3d-texturing-landing" element={<TexturingMainLanding/>}/>

            <Route key="3d-texturing" path="/3d-texturing" element={<TexturingContainer isVolumetric={false} isForRaf={true}/>} exact={true}/>
            <Route key="3d-texturing-c" path="/3d-texturing-c" element={<TexturingContainer isVolumetric={false} isForRaf={false}/>} exact={true}/>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
